export const PRIVE_WIDGETS_PAGE_TYPE = 'app-prive-page';
export const PRIVE_WIDGETS_PAGE_SECTION = '*';
export const PRIVE_ERROR_MSG = 'Error in fetching Prive Banners';
export const TierAmounts = {
  silver: 1500,
  gold: 5000,
  platinum: 15000,
};

export const faqList = [
  {
    title: 'What is Nykaa?',
    description:
      'Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups.',
  },
  {
    title: 'Is there a memebership fee for Nykaa Prive?',
    description:
      'Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups.',
  },
  {
    title: 'Is there a criteria to join Nykaa Prive?',
    description:
      'Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups.',
  },
];

export const priveDeeplinks = {
  reviewProduct: (origin: string) => `${origin}/?dl_type=order`,
  updateBirthday: (origin: string) => `${origin}/?dl_type=myaccount`,
  viewAllFaqs: (origin: string, redirectUrl: string) =>
    `${origin}/?dl_type=offer&url=${redirectUrl}&title=FAQS`,
  couponsTnC: (origin: string) =>
    `${origin}/?dl_type=offer&url=${origin}/coupon/tnc&title=TnC`,
  couponHelp: (origin: string) => `${origin}/?dl_type=help_center`,
  couponViewProducts: (origin: string, offerId: number) =>
    `${origin}/?dl_type=cartOffer&offer_id=${offerId}`,
  priveTnc: (origin: string, redirectUrl: string) =>
    `${origin}/?dl_type=offer&url=${redirectUrl}&title=TnC`,
};
